import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Waves } from "lucide-react";

const acts = [
  { v: "beach_cleanup", l: "Beach Cleanup" },
  { v: "food_drive", l: "Food Drive" },
  { v: "veterans", l: "Veterans Support" },
  { v: "outreach", l: "Local Outreach" },
  { v: "other", l: "Other" },
];

export default function Service() {
  const [items, setItems] = useState([]);
  const [summary, setSummary] = useState({ total_hours: 0, events: 0 });
  const [form, setForm] = useState({ player_name: "", activity: "beach_cleanup", date: "", hours: "", description: "" });
  const load = () => {
    api.get("/service").then((r) => setItems(r.data));
    api.get("/service/summary").then((r) => setSummary(r.data));
  };
  useEffect(load, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/service", { ...form, hours: Number(form.hours) });
      toast.success("Logged!");
      setForm({ player_name: "", activity: "beach_cleanup", date: "", hours: "", description: "" });
      load();
    } catch { toast.error("Failed"); }
  };
  return (
    <div data-testid="service-page">
      <div className="eyebrow mb-1">Community Service</div>
      <h1 className="font-display text-3xl uppercase mb-6">Service Tracker</h1>
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <div className="kr-card rounded-xl p-5"><Waves className="text-[#00E5FF] mb-2" size={20} /><div className="eyebrow">Total Hours</div><div className="font-display text-4xl mt-1">{summary.total_hours}</div></div>
        <div className="kr-card rounded-xl p-5"><Waves className="text-[#00E5FF] mb-2" size={20} /><div className="eyebrow">Events Logged</div><div className="font-display text-4xl mt-1">{summary.events}</div></div>
      </div>
      <div className="grid lg:grid-cols-[1fr_350px] gap-5">
        <div className="space-y-3">
          {items.map((i) => (
            <div key={i.id} className="kr-card rounded-xl p-4">
              <div className="flex justify-between">
                <div className="font-semibold">{i.player_name}</div>
                <div className="text-[#00E5FF] font-display text-xl">{i.hours}h</div>
              </div>
              <div className="text-xs text-slate-400 mt-1">{i.activity.replace("_", " ")} · {i.date}</div>
              {i.description && <div className="text-sm text-slate-300 mt-2">{i.description}</div>}
            </div>
          ))}
          {items.length === 0 && <p className="text-slate-500">No service logged yet.</p>}
        </div>
        <form onSubmit={submit} className="kr-card rounded-xl p-5 space-y-3 h-fit">
          <div className="eyebrow">Log Service</div>
          <input required placeholder="Player Name" value={form.player_name} onChange={(e) => setForm({ ...form, player_name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2" />
          <select value={form.activity} onChange={(e) => setForm({ ...form, activity: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2">
            {acts.map((a) => <option key={a.v} value={a.v}>{a.l}</option>)}
          </select>
          <input required type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2" />
          <input required type="number" step="0.25" placeholder="Hours" value={form.hours} onChange={(e) => setForm({ ...form, hours: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2" />
          <textarea rows={2} placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-2" />
          <button className="btn-primary w-full justify-center">Log Hours</button>
        </form>
      </div>
    </div>
  );
}
